module.exports = __webpack_public_path__ + "static/assets/74bde1e0cf8208279316d392a8e04f2c.png";